import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './invitees-dialog.styles'
import Button from 'pobble-components/dist/button'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Spinner from 'pobble-components/dist/spinner'
import Tooltip from 'pobble-components/dist/tooltip'
import MessageIcon from 'react-icons/lib/fa/envelope'
import { SubsCrown } from 'pobble-components/dist/subscriptions'

const InviteesDialog = ({
  classes,
  id,
  isOpen,
  onClose,
  onMount,
  pending,
  invitees
}) => {
  useEffect(() => {
    isOpen && onMount(id)
  }, [onMount, isOpen, id])
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Shared with</ModalHeader>
      <ModalContent legacy>
        {pending && <Spinner className={classes.spinner} />}
        <ul className={classes.invitees}>
          {invitees.map(invitee => (
            <li key={invitee.id} className={classes.invitee}>
              {invitee.guest_moderator.email_identity.email}
              {invitee.message && invitee.message !== '' && (
                <Tooltip content={invitee.message}>
                  <MessageIcon className={classes.msgIcon} />
                </Tooltip>
              )}
              {((invitee.guest_moderator.individual_subscription &&
                invitee.guest_moderator.individual_subscription
                  .plan_marketing_name) ||
                (invitee.guest_moderator.school_subscriptions &&
                  invitee.guest_moderator.school_subscriptions.length > 0 &&
                  invitee.guest_moderator.school_subscriptions[0] &&
                  invitee.guest_moderator.school_subscriptions[0]
                    .plan_marketing_name)) && (
                <Tooltip
                  content={
                    (invitee.guest_moderator.individual_subscription &&
                      invitee.guest_moderator.individual_subscription
                        .plan_marketing_name) +
                    ' ' +
                    (invitee.guest_moderator.school_subscriptions &&
                    invitee.guest_moderator.school_subscriptions[0] &&
                    invitee.guest_moderator.school_subscriptions.length > 0 &&
                    invitee.guest_moderator.school_subscriptions[0]
                      .plan_marketing_name
                      ? ',' +
                        invitee.guest_moderator.school_subscriptions[0]
                          .plan_marketing_name
                      : '')
                  }>
                  <SubsCrown className={classes.msgIcon} />
                </Tooltip>
              )}
            </li>
          ))}
        </ul>
      </ModalContent>
      <ModalFooter className={classes.footer}>
        <Button tall action={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default injectSheet(styles)(InviteesDialog)
